export default "__VITE_ASSET__b78a11b3__"